<template>
  <div class="quick_nav_menu_items">
    <div>
      <!-- POS menu items -->
      <ul class="flex" v-if="$route.name === 'pos' || $route.name === 'update_hold_invoice'">
        <li @click="navigateTo(item)" class="flex py-2 px-4 cursor-pointer items-center" v-for="(item, index) in menuItems" :key="index">
          <vx-tooltip :text="item.title || item.toolTip" v-if="item.title || item.toolTip" position="bottom" class="flex items-center">
            <feather-icon :icon="item.icon" svgClasses="w-6 mr-1" />
            <span v-show="item.isTitleShow">{{ item.title }}</span>
          </vx-tooltip>
        </li>
      </ul>

      <!-- POS (link) -->
      <ul class="flex" v-if="$route.name !== 'pos' && $route.name !== 'update_hold_invoice'">
        <li @click="navigateTo(item)" class="flex py-2 px-4 cursor-pointer items-center" v-for="(item, index) in defaultLinks" :key="index">
          <vx-tooltip :text="item.title || item.toolTip" v-if="item.title || item.toolTip" position="bottom" class="flex items-center">
            <feather-icon :icon="item.icon" svgClasses="w-6 mr-2" />
            <span v-show="item.isTitleShow">{{ item.title }}</span>
          </vx-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'QuickNavMenuItems',
  data() {
    return {
      menuItems: [
        {
          icon: 'PauseCircleIcon',
          title: 'Hold',
          action: this.toggleHoldInvoiceTable,
          isTitleShow: true
        },
        {
          icon: 'AirplayIcon',
          toolTip: 'Fullscreen On/Off',
          cb: () => {
            this.toggleFullscreen()
          }
        },
        {
          icon: 'HomeIcon',
          title: 'Dashboard',
          isTitleShow: true,
          link: ''
        }
      ],

      defaultLinks: [
        {
          icon: 'ShoppingCartIcon',
          title: 'POS',
          link: 'pos',
          isTitleShow: true
        }
      ],

      is_popup_hold_invoice_open: false
    }
  },
  mounted() {
    // clsoe the hold Invocie popup
    this.$root.$on('close_hold_invoices', (status) => {
      this.is_popup_hold_invoice_open = status
    })
  },
  methods: {
    ...mapMutations({ toggleFullscreen: 'TOGGLE_FULLSCREEN' }),
    // Navigate to Route
    navigateTo(item) {
      if (item.link || item.link === '') {
        this.$router.push(`/${item.link}`).catch(() => {})
      }

      if (item.action) {
        item.action()
      }

      if (item.cb) {
        item.cb()
      }
    },

    // Open Hold Invocie list
    toggleHoldInvoiceTable() {
      this.is_popup_hold_invoice_open = !this.is_popup_hold_invoice_open
      this.$root.$emit('toggle_hold_invoices', this.is_popup_hold_invoice_open)
    }
  }
}
</script>

<style>
</style>